import { AnalyticsStore } from 'bernie-plugin-mobx';

import { trackCountsFormAnalytics, trackAnalytics } from 'utility';
import { FlightsTravelerType } from '__generated__/api';
import { FlightsSearchFormTravelersOption } from 'types/search/wizard';
import { SearchFormStore } from '../stores';

export const getAgeOptionsDataTestId = (labelTemplate: string, labelToken: string, itr: number): string => {
  const dataTestId = `${labelTemplate}select-${itr}`;

  return dataTestId.replace(labelToken, '').replace(/ /g, '-').toLowerCase();
};

export const INFANT_AGE_LIMIT = 1;

const getSelectedAnalyticsByType = (type: string, travelerOptions: FlightsSearchFormTravelersOption) => {
  const { ADULT, CHILD, INFANT_IN_LAP, INFANT_IN_SEAT } = FlightsTravelerType;
  const { adultSelectedAnalytics, childrenSelectedAnalytics, infantSelectedAnalytics } = travelerOptions;

  switch (type) {
    case ADULT:
      return adultSelectedAnalytics;
    case CHILD:
      return childrenSelectedAnalytics;
    case INFANT_IN_LAP:
    case INFANT_IN_SEAT:
      return infantSelectedAnalytics;
  }
};

const getTrackableAnalytics = (type: string, travelerOptions: FlightsSearchFormTravelersOption) => {
  const { INFANT_IN_LAP, INFANT_IN_SEAT } = FlightsTravelerType;
  const { infantLapAnalytics, infantSeatAnalytics } = travelerOptions;

  switch (type) {
    case INFANT_IN_LAP:
      return infantLapAnalytics;
    case INFANT_IN_SEAT:
      return infantSeatAnalytics;
  }
};

export const trackTravelersOptions = (
  travelerOptions: FlightsSearchFormTravelersOption,
  analytics: AnalyticsStore,
  searchFormStore: SearchFormStore
) => {
  travelerOptions.items.map((travelerOptionItem, index) => {
    const { INFANT_IN_LAP, INFANT_IN_SEAT } = FlightsTravelerType;
    const { type, travelerCount } = travelerOptionItem;
    const initialTravelerCount = searchFormStore.initialTravelerOptions[index]?.travelerCount;
    const initialTravelerType = searchFormStore.initialTravelerOptions[index]?.type;
    const changeInTravelerCount = initialTravelerCount !== travelerCount;
    const infantType = type === INFANT_IN_LAP || INFANT_IN_SEAT;
    const changeInInfantsSeatingSetting = initialTravelerType !== type || (infantType && initialTravelerCount === 0);

    const selectedAnalytics = getSelectedAnalyticsByType(type, travelerOptions);
    const trackableAnalytics =
      travelerCount > 0 && changeInInfantsSeatingSetting ? getTrackableAnalytics(type, travelerOptions) : null;

    if (changeInTravelerCount) {
      trackCountsFormAnalytics(analytics, selectedAnalytics, travelerCount);
    }
    if (changeInInfantsSeatingSetting && trackableAnalytics) {
      trackAnalytics(trackableAnalytics, analytics);
    }
  });
};
